import axios from 'axios';
import { API_BASE_URL } from '../utils/constants';

export const applyOrgTheme = async (organizationId) => {
  if (!organizationId) return null;
  try {
    const response = await axios.get(`${API_BASE_URL}/brand/theme`, {
      params: { organizationId },
    });
    const brand = response.data?.result;
    if (brand?.themeColors?.primary) {
      document.documentElement.style.setProperty('--primary-color', brand.themeColors.primary);
    }
    return brand || null;
  } catch {
    return null;
  }
};
